<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="档案详情" size="75%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <!-- 服务商 -->
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    档案号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.profileNo }}</span>


                    <!-- <span class="information">
                      {{formData.stat == '1'?'登记':formData.stat == '2'?'发布':formData.stat == '5'?'已派网点':formData.stat == '9'?'已派师傅':formData.stat == '13'?'已出发':formData.stat == '17'?'已上门':formData.stat == '20'?'完工暂存':formData.stat == '21'?'已完工':formData.stat == '22'?'网点确定完工':formData.stat == '23'?'中心确定完工':formData.stat == '24'?'总部确定完工':formData.stat == '91'?'待结算':formData.stat == '92'?'结算驳回':formData.stat == '93'?'结算中止':formData.stat == '94'?'已结算':formData.stat == '98'?'挂起':'取消'}}</span> -->
                    <!-- 状态 -->
                    <span v-if="!dataId" class="information"> 制单</span>
                    <span v-else-if="formData.stat == 1" class="information">待审</span>
                    <span v-else-if="formData.stat == 2" class="information">已审</span>
                    <span v-else-if="formData.stat == 99" class="information">作废</span>
                    <span v-else class="information"></span>
                  </div>
                </div>




                <div class="d-cont edit-mce-box">

                  <div class="d-item">
                    <div class="title first"><b>主信息</b></div>
                    <table class="table-detail">
                      <tbody>

                        <tr style="display: block;">
                          <!-- <th>

                    厂商名称
                  :</th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.userAccount" clearable />
                  </td> -->
                          <!-- <th>工单号:</th>
                          <td>{{ formData.orderNo }}</td>
                          <th>生成方式:</th>
                          <td v-if="formData.createType==0">默认</td>
                          <td v-if="formData.createType==1">客服</td>
                          <td v-if="formData.createType==2">excel</td>
                          <td v-if="formData.createType==3">接口</td>
                          <td v-if="formData.createType==4">公众号</td>
                          <td v-if="formData.createType==5">自建单</td>
                          <td v-if="formData.createType==6">APP自建单</td>
                          <td v-if="formData.createType==7">服务中心</td>
                          <td v-if="formData.createType==9">其它</td>
                          <td v-if="formData.createType==94">苏宁帮客</td>
                          <td v-if="formData.createType==95">京东服务市场</td>
                          <td v-if="formData.createType==97">天猫服务市场</td>
                          <td v-if="formData.createType==98">京东测量服务</td>
                          <td v-if="formData.createType==99">京东ue平台</td>
                          <td v-if="formData.createType==100">京东3C</td> -->

                          <th>姓名/号码:</th>
                          <td>{{ formData.custName }} / {{ formData.callMobile }}</td>
                          <th>
                            性别:
                          </th>

                          <td v-if="formData.sex == 1">男</td>
                          <td v-else-if="formData.sex == 2">女</td>
                          <td v-else>未知</td>




                          <th>
                            性格类型:
                          </th>
                          <template v-if="formData.natureType"> 
                          <td v-for="item in dictTypesNatureType" :key="item.id" :label="item.label" :value="item.value"
                            >
                            {{ item.label }}
                          </td></template>
                          <td v-else></td>
                          <th>
                            文化水平:
                          </th>
                          <td v-for="item in dictTypesEducationLevel" :key="item.id" :label="item.label"
                            :value="item.value" v-if="shouldShowItem2(item)">
                            {{ item.label }}
                          </td>
                          <!-- <th>详细地址:</th>
                          <td style="width: 20vw!important;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;">
                            {{ formData.userProvice }}{{ formData.userCity }}{{
                              formData.userCounty
                            }}{{ formData.userTown }}{{ formData.userAddress }}
                          </td> -->
                        </tr>
                        <tr style="display: block;">
                          <th>用户类型:</th>
                          <td v-if="formData.custType == 0">普通用户</td>
                          <td v-else-if="formData.custType == 1">售前用户</td>
                          <td v-else-if="formData.custType == 2">工程用户</td>
                          <td v-else-if="formData.custType == 3">VIP用户</td>
                          <td v-else-if="formData.custType == 4">经销商</td>
                          <td v-else></td>
                          <th>创建方式:</th>
                          <td v-if="formData.createType == 0">其他方式</td>
                          <td v-else-if="formData.createType == 1">工单产生</td>
                          <td v-else-if="formData.createType == 2">后台录入</td>
                          <td v-else-if="formData.createType == 3">微信录入</td>
                          <td v-else-if="formData.createType == 4">接口导入</td>
                          <td v-else></td>
                          <th>机构名称:</th>
                          <td>{{ formData.orgName }}</td>
                          <th>
                            VIP级别:
                          </th>
                          <td v-for="item in dictTypesVipLevel" :key="item.id" :label="item.label" :value="item.value"
                            v-if="shouldShowItem3(item)">
                            {{ item.label }}
                          </td>



                        </tr>
                        <tr style="display: block;">
                          <th>
                            来电信息:
                          </th>
                          <div v-if="formData.callInfo">
                          <td v-for="item in dictTypesCallInfo" :key="item.id" :label="item.label" :value="item.value"
                            >
                            {{ item.label }}
                          </td>
                        </div>
                          <td v-else></td>
                          <th>
                            用户身份:
                          </th>
                          <div v-if="formData.custIdentity">
                          <td v-for="item in dictTypesCustIdentity" :key="item.id" :label="item.label" :value="item.value"
                            >
                            {{ item.label }}
                          </td></div>
                          <td v-else></td>

                          <th>
                            风险把控:
                          </th>
                          <div v-if="formData.callInfo">
                          <td v-for="item in dictTypesCustRisk" :key="item.id" :label="item.label" :value="item.value"
                            >
                            {{ item.label }}
                          </td>
                        </div>
                          <td v-else></td>

                          <th>来电号码:</th>
                          <td>{{ formData.callMobile }}</td>
                        </tr>

                        <tr>

                          <th>网点名称:</th>
                          <td>{{ formData.siteName }}</td>

                          <th>源于工单:</th>
                          <td>{{ formData.orderNo }}</td>

                          <th> 微信openId:</th>
                          <td>{{ formData.openId }}</td>
                          <th>状态:</th>
                          <td v-if="formData.stat == 1">待审</td>
                          <td v-else-if="formData.stat == 2">已审</td>
                          <td v-else-if="formData.stat == 9">做废</td>
                          <td v-else></td>
                        </tr>
                        <tr>
                          <th>
                            特别事项:
                          </th>
                          <td>{{ formData.specailRemark }}</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>地址信息</b></div>
                    <vxe-table :stripe="true"
                      :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                      :header-row-style="{ height: '36px' }"
                      :row-style="{ height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                      ref="xTable" height="150" :row-config="{ height: 36 }" :column-config="{ resizable: true }"
                      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                      :data="formData.basCustAddressList">

                      <vxe-column type="seq" width="35" />
                      <vxe-column field="custName" title="联系人" width="110" />
                      <vxe-column field="custMobile" title="联系方式" width="110" />
                      <vxe-column field="custPhone1" title="其他电话1" width="110" />
                      <vxe-column field="custPhone2" title="其他电话2" width="110" />
                      <vxe-column title="地址" width="180">
                        <template #default="{ row }">
                          <span>{{ row.custProvince }}{{ row.custCity }}{{ row.custCounty }}{{ row.custTown }}</span>
                        </template>
                      </vxe-column>
                      <vxe-column field="custAddress" title="详细地址" width="180" />
                      <vxe-column field="isDefault" title="是否默认地址" width="100">
                        <template #default="{ row }">
                          <span v-if="row.isDefault == 1">是</span>
                          <span v-if="row.isDefault == 0">否</span>
                        </template>
                      </vxe-column>
                    </vxe-table>
                  </div>
                  <!-- 用户资产 -->
                  <div class="d-item">
                    <div class="title first"><b>用户资产</b></div>
                    <vxe-table :stripe="true"
                      :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                      :header-row-style="{ height: '36px' }"
                      :row-style="{ height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                      ref="xTable" height="150" :row-config="{ height: 36 }" :column-config="{ resizable: true }"
                      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }" :data="formData.basCustAsseList"
                      @radio-change="currentChange">
                      <vxe-column type="radio" width="35" />
                      <vxe-column field="brandName" title="品牌名称" width="110" />
                      <vxe-column field="itemName" title="产品名称" width="110" />
                      <vxe-column field="stat" title="资产状态" width="80">
                        <template #default="{ row }">
                          <span v-if="row.stat == 1">可用</span>
                          <span v-if="row.stat == 0">不可用</span>
                        </template>
                      </vxe-column>
                      <vxe-column field="barcode" title="主条码" width="150" />
                      <vxe-column field="instDate" title="安装时间" width="110" />
                      <vxe-column field="standPeriodMonth" title="基本保修期(按月)" width="120" />
                      <vxe-column field="extendPeriodMonth" title="延长保修期(按月)" width="120" />
                    </vxe-table>
                  </div>
                  <!-- 用户权益 -->
                  <div class="d-item">
                    <div class="title first"><b>用户权益</b></div>
                    <div>
                      <div v-if="formData.basCustRightsList.length > 0">
                        <div class="quanYi" style="width:;height: 100px;width:70% "
                          v-for="item in formData.basCustRightsList" :key="item.id">
                          <p class="quanYi_item">
                            <span class="sapn1" style="width:25%">
                              <span class="span1" style="font-size: 15px;color: black;">{{ item.rightsName }}*</span>
                              <span class="span2"
                                v-if="item.rightsStat == null || item.rightsStat == undefined">未激活</span>
                              <span class="span2" v-if="item.rightsStat == 0">未激活</span>
                              <span class="span2" v-if="item.rightsStat == 1">有效</span>
                              <span class="span2" v-if="item.rightsStat == 3">失效</span>
                              <span class="span2" v-if="item.rightsStat == 9">做废</span>
                            </span>
                            <span class="sapn1" style="width:25%">
                              <span class="span1">权益码：</span><span class="span2">{{ item.rightsNo }}</span>
                            </span>
                            <span class="sapn1" style="width:50%"><span class="span1" style="width:9vw">有效时间：</span><span
                                class="span2">{{ item.beginDate.split(" ")[0] }}-{{ item.endDate.split(" ")[0] }}
                              </span></span>
                          </p>
                          <p class="quanYi_item">
                            <span class="sapn1" style="width:25%">
                              <span class="span1">权益名称：</span><span class="span2">{{ item.rightsName }}</span>

                            </span>
                            <span class="sapn1" style="width:25%">
                              <span class="span1">绑定条码：</span><span class="span2">{{ item.barcode }}</span>
                            </span>
                            <span class="sapn1" style="width:50%" v-if="item.countTimesType == 2">
                              <span class="span1" style="width:9vw">已使用/可使用次数：</span><span class="span2">{{
                                item.uesedTimes }}/{{ item.unUesedTimes }}
                              </span></span>
                            <span class="sapn1" style="width:50%" v-else>
                              <span class="span1" style="width:9vw">权益时间：</span><span class="span2">{{ item.uesedTimes
                              }}个月
                              </span></span>

                          </p>
                          <p style="float: right;margin: 0; margin-right: 20px; ">
                            <span class="clause">查看权益条款</span>
                            <span class="clause" style="margin-left: 20px;"
                              @click="openRecordDialog(item.id)">查看核销记录</span>
                          </p>
                        </div>
                      </div>
                      <div v-else style="text-align: center;font-size: 14px;color: #606266;">暂无数据 </div>
                    </div>
                  </div>
                  <!-- 用户资产 -->
                  <div class="d-item">
                    <div class="title first"><b>更换配件</b></div>
                    <vxe-table :column-config="{ resizable: true }" :stripe="true"
                      :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                      :header-row-style="{ height: '36px' }"
                      :row-style="{ height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                      ref="aaaa" height="100" :data="partsList"
                      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }">
                      <vxe-column field="partsName" title="新配件名称" width="110" />
                      <vxe-column field="partsCode" title="新配件编码" width="110" />
                      <vxe-column field="oldPartsName" title="旧配件名称" width="110" />
                      <vxe-column field="oldPartsCode" title="旧配件编码" width="110" />
                      <vxe-column field="sitePrice" title="网点价" width="80" />
                      <vxe-column field="qty" title="更换数量" width="80" />
                      <vxe-column field="amount" title="金额" width="80" />
                      <vxe-column field="returnQty" title="网点返厂数量" width="110" />
                      <vxe-column field="returnRevQty" title="返厂数量" width="80" />
                      <vxe-column field="isNeedReturn" title="是否需要返厂" width="110">
                        <template #default="{ row }">
                          <span v-if="row.isNeedReturn == 1">是</span>
                          <span v-if="row.isNeedReturn == 0">否</span>
                        </template>
                      </vxe-column>
                      <vxe-column field="isCheck" title="是否已经审核" width="110">
                        <template #default="{ row }">
                          <span v-if="row.isCheck == 1">是</span>
                          <span v-if="row.isCheck == 0">否</span>
                        </template>
                      </vxe-column>
                    </vxe-table>
                  </div>


                  <div style="height: 10px;"></div>

                </div>


              </el-form>
            </div>
          </div>
        </template>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'
import api from "@/api/projectApi";
// import DictValueShow from "@/components/formItem/dictValueShow.vue";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'row3'],
  components: {
    // DictValueShow

  },
  created() {
    this.dataId = this.row3
    console.log(this.dataId, "传过来的值");
  },
  data() {
    return {
      // 性格类型
      dictTypesNatureType: [],
      // 文化水平
      dictTypesEducationLevel: [],
      // VIP级别
      dictTypesVipLevel: [],
      // 来电信息
      dictTypesCallInfo: [],
      // 用户身份
      dictTypesCustIdentity: [],
      // 风险把控
      dictTypesCustRisk: [],


      show3: false,
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,

      drawer: true,
      formData: {},
      srcList: [],
      partsList: []

    }
  },
  mounted() {
    // this.initTableList();
    this.getData();
    this.getDictTypes()

    //   console.log(this.tenant, "tenant的值");
    console.log(this.dataId, "_dataId的值");
  },
  methods: {
    currentChange({ row }) {
      console.log('row', row)
      this.selectItemData = [row]
      if (row.id) {
        // this.showParts = false
        this.$http({
          url: api.basCustAsset.getPartsDataUrl,
          method: 'post',
          data: {
            id: row.id
          }
        }).then(res => {
          if (res.data.data.length !== 0 && res.data.data[0] != null) {
            this.partsList = res.data.data
          } else {
            this.partsList = []
          }
          // this.showParts = true
        })
      } else {
        console.log('kong',);
        this.partsList = []
      }
      console.log(this.partsList, "partsList的值");
      // this.reload()

      // this.$refs['aaaa'].commitProxy('reload');

    },
    // 性格类型

    shouldShowItem(item) {
      console.log(item, this.formData.natureType, '性格类型');
      // 根据值选择展示哪一个
      // 这里可以根据你的逻辑进行判断
      // 返回 true 表示展示该项，返回 false 表示不展示
      return item.value === this.formData.natureType;
    },
    // 文化水平
    shouldShowItem2(item) {
      // console.log(item,this.formData.educationLevel,'educationLevel型');
      return item.value === this.formData.educationLevel;
    },

    // VIP级别
    shouldShowItem3(item) {
      return item.value === this.formData.vipLevel;
    },
    shouldShowItem4(item) {
      return item.value === this.formData.callInfo;
    },
    shouldShowItem5(item) {
      return item.value === this.formData.custIdentity;
    },
    shouldShowItem6(item) {
      return item.value === this.formData.custRisk;
    },
    getDictTypes() {
      this.$http({
        url: "/admin/dict/type/vip_level",
        method: 'get',
      }).then(res => {
        this.dictTypesVipLevel = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/call_info",
        method: 'get',
      }).then(res => {
        this.dictTypesCallInfo = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/nature_type",
        method: 'get',
      }).then(res => {
        this.dictTypesNatureType = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/education_level",
        method: 'get',
      }).then(res => {
        this.dictTypesEducationLevel = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/cust_identity",
        method: 'get',
      }).then(res => {
        this.dictTypesCustIdentity = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/cust_risk",
        method: 'get',
      }).then(res => {
        this.dictTypesCustRisk = res.data.data;
      })
    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        //   this.isEdit = true;
        this.$http({
          url: api.basCustProfile.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          this.formData.natureType = response.data.data.natureType


          console.log(this.formData, "this.formData请求的值");

          if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
            this.formData.soOrderComplainDTOList.forEach(item => {
              let list = []
              if (item.fileUrl1 != null) {
                list.push(item.fileUrl1)
              }
              if (item.fileUrl2 != null) {
                list.push(item.fileUrl)
              }
              if (item.fileUrl3 != null) {
                list.push(item.fileUrl3)
              }
              item.srcList = list
            })
          }
        })
      } else {
        this.enabled = true;
      }
    },
    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
    },
    shut() {
      // this.showOrderPop=true
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD3', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0, );
        max-width: 10vw;
    overflow: hidden;
    overflow-x: scroll;
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}
</style>
